import { createFileRoute } from '@tanstack/react-router';
import { parseItemDetailSearch, type ItemDetailSearch } from '@/features/items/item-detail-search';
import { ItemDetailPage } from '@/features/items/item-detail-page';

export const Route = createFileRoute('/_app/items/$itemId')({
  // ?tab= keeps the open tab in the URL (C39: items are addressed by id);
  // ?v= is the BOM version the Ürün ağacı tab shows
  validateSearch: (s: Record<string, unknown>): ItemDetailSearch => parseItemDetailSearch(s),
  component: function ItemDetail() {
    const { itemId } = Route.useParams();
    return <ItemDetailPage itemId={itemId} search={Route.useSearch()} />;
  },
});
